import React from 'react';

import CalculatorForm from './CalculatorForm';
import * as c from '../appConstants';
import PropTypes from 'prop-types';

const submitFormData = {
  price_per_pack: c.DEFAULT_PACK_PRICE,
  cigarettes_per_day: c.DEFAULT_CIGS_SMOKED_DAILY,
  isPageLoad: true,
};

export default class CalculatorTrigger extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onSubmit(submitFormData);
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-10 col-xs-offset-1 CalculatorTrigger">
          <div className="h6 navy left CalculatorTrigger__title">
            Tell us about you
          </div>
          <div className="CalculatorTrigger__separator" />
          <CalculatorForm onSubmit={this.props.onSubmit} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/components/CalculatorTrigger.js